import React from 'react';
import UserLayout from '../components/UserLayout';
import PromotionDetail from '../components/PromotionDetail';

const PromotionDetailPage = () => (
  <UserLayout>
    <PromotionDetail />
  </UserLayout>
);

export default PromotionDetailPage;
